import { TreeTableDesignTokens } from '@primeng/themes/types/treetable';

interface ICustomTreeTableDesignTokens extends TreeTableDesignTokens {
  row: TreeTableDesignTokens['row'] & {
    stripedBackground: string;
  };
  sortIcon: TreeTableDesignTokens['sortIcon'] & {
    size: string;
  };
}

export const baseTreetableToken: ICustomTreeTableDesignTokens = {
  header: {
    borderWidth: '0',
    padding: '0',
  },
  headerCell: {
    hoverBackground: 'transparent',
    selectedBackground: 'transparent',
    borderColor: 'transparent',
    color: '{gray.600}',
    hoverColor: '{gray.600}',
    selectedColor: '{gray.600}',
    padding: '0.125rem 1rem 0.125rem 0.125rem',
  },
  columnTitle: {
    fontWeight: '500',
  },
  row: {
    hoverBackground: '{neutral.500}',
    selectedBackground: '{neutral.500}',
    color: '{gray.600}',
    hoverColor: '{gray.600}',
    selectedColor: '{gray.600}',
    stripedBackground: '{other.gray.50}',
  },
  bodyCell: {
    borderColor: 'transparent',
    padding: '0.125rem 1rem 0.125rem 0.125rem',
  },
  sortIcon: {
    size: '1.25rem',
  },
  nodeToggleButton: {
    hoverBackground: 'transparent',
    size: '1rem',
    borderRadius: '0',
  },
  // it can be as default settings, but to not break the original design it was moved to additional classes
  // should be checked in the future trees
  //  fix-flex-scroll-height: flex height for scrolled table limited by parent max-height
  //  fix-header-border-spacing: fix for border-spacing if all table has 1, but header should have 0
  //  fix-row-focus: to remove row focus
  //  striped-treetable: add stripped rows for tree
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    p-treetable.fix-flex-scroll-height {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 0;
    }

    p-treetable.fix-flex-scroll-height .p-treetable {
      min-height: 0;
    }

    p-treetable.fix-flex-scroll-height .p-treetable-scrollable-wrapper {
      min-height: 0;
    }

    p-treetable.fix-flex-scroll-height .p-treetable-scrollable-view {
      min-height: 0;
    }

    p-treetable.fix-header-border-spacing .p-treetable-scrollable-header-table {
      border-spacing: 0;
    }

    p-treetable.fix-row-focus tr[tabindex="0"]:focus {
     outline: none;
    }

    p-treetable.striped-treetable .p-treetable-tbody > tr:nth-child(odd) {
      background-color: ${dt('treetable.row.stripedBackground')};
    }
  `,
};
